export default "__VITE_ASSET__60e244d2__"